import { formatMoney, formatNumber } from '@platform/design-system';
import { usePageContext } from '../../usePageContext.ts';
import type { OverviewFormat } from '../overview-tiles.ts';

export const useOverviewFormat = (): OverviewFormat => {
  const { t, locale } = usePageContext();
  return {
    money: (amount, currency) => formatMoney({ amount, currency }, locale),
    count: (value) => formatNumber(value, locale),
    counted: (key, value, values = {}) =>
      t(`dashboard.overview.${key}`, { ...values, count: value, total: formatNumber(value, locale) }),
    range: (range, currency) => {
      const min = formatMoney({ amount: range.min, currency }, locale);
      return range.min === range.max
        ? min
        : `${min} – ${formatMoney({ amount: range.max, currency }, locale)}`;
    },
  };
};
